import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class LogService {
    private apiUrl = environment.apiUrl;
    constructor(private http: HttpClient) { }

    getConversations(): Observable<any> {
        return this.http.get<any>(this.apiUrl + '/admin/conversations');
    }

    getMessages(conversationId: number): Observable<any> {
        return this.http.get<any>(this.apiUrl + '/admin/conversations/' + conversationId + '/messages');
    }
}
